import { MotionAnimation } from "./types";

const outerGradientReversed: MotionAnimation[] = [
  [
    "#reversed-gold-gradient-white-highlight-large-moving-left",
    {
      x1: "-250%",
      x2: "-200%",
    },
    {
      duration: 3,
      ease: "linear",
    },
  ],
  [
    "#reversed-gold-gradient-white-highlight-large-moving-right",
    {
      x1: "150%",
      x2: "100%",
    },
    {
      duration: 3,
      ease: "linear",
    },
  ],
];

const middleGradient: MotionAnimation[] = [
  [
    "#gold-gradient-white-highlight-moving-left",
    {
      x1: "0%",
      x2: "-100%",
    },
    {
      duration: 3,
      ease: "linear",
    },
  ],
  [
    "#gold-gradient-white-highlight-moving-right",
    {
      x1: "100%",
      x2: "150%",
    },
    {
      duration: 3,
      ease: "linear",
    },
  ],
];

const middleGradientReversed: MotionAnimation[] = [
  [
    "#reversed-gold-gradient-white-highlight-moving-left",
    {
      x1: "0%",
      x2: "-100%",
    },
    {
      duration: 3,
      ease: "linear",
    },
  ],
  [
    "#reversed-gold-gradient-white-highlight-moving-right",
    {
      x1: "100%",
      x2: "150%",
    },
    {
      duration: 3,
      ease: "linear",
    },
  ],
];

const outerGradient: MotionAnimation[] = [
  [
    "#gold-gradient-white-highlight-large-moving-left",
    {
      x1: "-250%",
      x2: "-200%",
    },
    {
      duration: 3,
      ease: "linear",
    },
  ],
  [
    "#gold-gradient-white-highlight-large-moving-right",
    {
      x1: "150%",
      x2: "100%",
    },
    {
      duration: 3,
      ease: "linear",
    },
  ],
];

const showOuterGradientPaths: MotionAnimation[] = [
  [
    "#path22",
    {
      opacity: 1,
    },
    {
      opacity: {
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path23",
    {
      opacity: 1,
    },
    {
      opacity: {
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path24",
    {
      opacity: 1,
    },
    {
      opacity: {
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path25",
    {
      opacity: 1,
    },
    {
      opacity: {
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path22-reversed-gradient",
    {
      opacity: 0,
    },
    {
      opacity: {
        delay: 0.2,
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path23-reversed-gradient",
    {
      opacity: 0,
    },
    {
      opacity: {
        delay: 0.2,
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path24-reversed-gradient",
    {
      opacity: 0,
    },
    {
      opacity: {
        delay: 0.2,
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path25-reversed-gradient",
    {
      opacity: 0,
    },
    {
      opacity: {
        delay: 0.2,
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
];

const showReversedMiddleGradientPaths: MotionAnimation[] = [
  [
    "#path5-reversed-gradient",
    {
      opacity: 1,
    },
    {
      opacity: {
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path6-reversed-gradient",
    {
      opacity: 1,
    },
    {
      opacity: {
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path5",
    {
      opacity: 0,
    },
    {
      opacity: {
        delay: 0.2,
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path6",
    {
      opacity: 0,
    },
    {
      opacity: {
        delay: 0.2,
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
];

const showMiddleGradientPaths: MotionAnimation[] = [
  [
    "#path5",
    {
      opacity: 1,
    },
    {
      opacity: {
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path6",
    {
      opacity: 1,
    },
    {
      opacity: {
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path5-reversed-gradient",
    {
      opacity: 0,
    },
    {
      opacity: {
        delay: 0.2,
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path6-reversed-gradient",
    {
      opacity: 0,
    },
    {
      opacity: {
        delay: 0.2,
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
];

const showReversedOuterGradientPaths: MotionAnimation[] = [
  [
    "#path22",
    {
      opacity: 0,
    },
    {
      opacity: {
        delay: 0.2,
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path23",
    {
      opacity: 0,
    },
    {
      opacity: {
        delay: 0.2,
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path24",
    {
      opacity: 0,
    },
    {
      opacity: {
        delay: 0.2,
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path25",
    {
      opacity: 0,
    },
    {
      opacity: {
        delay: 0.2,
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path22-reversed-gradient",
    {
      opacity: 1,
    },
    {
      opacity: {
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path23-reversed-gradient",
    {
      opacity: 1,
    },
    {
      opacity: {
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path24-reversed-gradient",
    {
      opacity: 1,
    },
    {
      opacity: {
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
  [
    "#path25-reversed-gradient",
    {
      opacity: 1,
    },
    {
      opacity: {
        duration: 0.01,
      },
      ease: "linear",
    },
  ],
];

const outerGradientReset: MotionAnimation[] = [
  [
    "#gold-gradient-white-highlight-large-moving-left",
    {
      x1: "100%",
      x2: "200%",
    },
    {
      duration: 0.1,
      ease: "linear",
    },
  ],
  [
    "#gold-gradient-white-highlight-large-moving-right",
    {
      x1: "-100%",
      x2: "-200%",
    },
    {
      duration: 0.1,
      ease: "linear",
    },
  ],
];

const outerGradientReversedReset: MotionAnimation[] = [
  [
    "#reversed-gold-gradient-white-highlight-large-moving-left",
    {
      x1: "100%",
      x2: "200%",
    },
    {
      duration: 0.1,
      ease: "linear",
    },
  ],
  [
    "#reversed-gold-gradient-white-highlight-large-moving-right",
    {
      x1: "-100%",
      x2: "-200%",
    },
    {
      duration: 0.1,
      ease: "linear",
    },
  ],
];

const middleGradientReset: MotionAnimation[] = [
  [
    "#gold-gradient-white-highlight-moving-left",
    {
      x1: "200%",
      x2: "100%",
    },
    {
      duration: 0.1,
      ease: "linear",
    },
  ],
  [
    "#gold-gradient-white-highlight-moving-right",
    {
      x1: "-100%",
      x2: "0%",
    },
    {
      duration: 0.1,
      ease: "linear",
    },
  ],
];

const middleGradientReversedReset: MotionAnimation[] = [
  [
    "#reversed-gold-gradient-white-highlight-moving-left",
    {
      x1: "200%",
      x2: "100%",
    },
    {
      duration: 0.1,
      ease: "linear",
    },
  ],
  [
    "#reversed-gold-gradient-white-highlight-moving-right",
    {
      x1: "-100%",
      x2: "0%",
    },
    {
      duration: 0.1,
      ease: "linear",
    },
  ],
];

export {
  middleGradient,
  middleGradientReset,
  middleGradientReversed,
  middleGradientReversedReset,
  outerGradient,
  outerGradientReversed,
  outerGradientReset,
  outerGradientReversedReset,
  showOuterGradientPaths,
  showReversedOuterGradientPaths,
  showMiddleGradientPaths,
  showReversedMiddleGradientPaths,
};
